<h3 class="title">Payment Details</h3>

<terra-unit-payment-overview-key-value-pair key="Amount" [value]="payment.amount | terraNumber" unit="$" />
@if(payment.status !== UnitPaymentStatus.Sent){
    <terra-unit-payment-overview-key-value-pair key="Account Balance after Transaction" [value]="balanceAfterTransaction | terraNumber" unit="$" />
}
<terra-unit-payment-overview-key-value-pair key="Description (External)" [value]="payment.description" />
@if(payment.memo){
    <terra-unit-payment-overview-key-value-pair key="Memo" [value]="payment.memo" />
}
<terra-unit-payment-overview-key-value-pair key="Internal Notes" [value]="payment.internalNotes" />
<terra-unit-payment-overview-key-value-pair key="Type of Transaction" [value]="payment.paymentType | enumString: UnitPaymentType" />
<terra-unit-payment-overview-key-value-pair key="Date of Transaction" [value]="dateOfTransaction" />
<terra-unit-payment-overview-key-value-pair key="Category" [value]="payment.category | enumString: UnitPaymentCategory" />
<terra-unit-payment-overview-key-value-pair key="Reference Number" [value]="payment.referenceNumber" />
